import {autorun, action, observable, runInAction} from 'mobx';
import {materializeValues} from '../utils'; 
import confirmationDialog from '../model/ConfirmationDialog'; 
import translateBase from '../translate';
let translate = translateBase.bindComponent('commonPersonalData');

export class VUserProfile {
  constructor(flasher, api, navigation, masterData, authentication, personalData, rentalTransaction, 
    personalDataForm, personalAddressForms) {
    this.flasher = flasher;
    this.api = api;
    this.navigation = navigation;
    this.masterData = masterData;
    this.authentication = authentication;
    this.personalData = personalData;
    this.personalDataForm = personalDataForm;
    this.personalAddressForms = personalAddressForms;
  }
  
  @observable usingPostAsBilling = true;
  
  @action.bound usePostAsBilling() {
    this.usingPostAsBilling = !this.usingPostAsBilling;
  } 

  @action.bound async updateProfile() { 
    try {
      this.personalDataForm.setPurpose(this.personalDataForm.PURPOSES.PROFILE_EDIT);
      this.personalDataForm.readOnlyAll = false;
      this.personalDataForm.visitAll();
      if(!this.personalDataForm.allValid) {
        throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
      }
      
      this.personalAddressForms[0].visitAll();
      if(!this.usingPostAsBilling) {
        this.personalAddressForms[1].visitAll();
      }
      if(!this.personalAddressForms[0].allValid) {
        throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
      }      
      if(!this.usingPostAsBilling && !this.personalAddressForms[1].allValid) {
        throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
      } 

      try {
        this.flasher.setOther('Loading.');
        await this.personalData.update({
          organizationId: this.orgId,
          userDetails: materializeValues(this.personalDataForm.values),
          addresses: [
            this.personalAddressForms[0].values,
            this.usingPostAsBilling ?
              this.personalAddressForms[0].values
            : 
              this.personalAddressForms[1].values,
          ]
        })
        const fi = this.personalDataForm.initialValues;
        const fd = this.personalDataForm.dirtyValues;
        if(fi.oldPassword !== fd.oldPassword || fi.password1 !== fd.password1 || fi.password2 !== fi.password2) {
          const passwordChanger = {
            oldPassword: this.personalDataForm.values.oldPassword, 
            password1: this.personalDataForm.values.password1, 
            password2: this.personalDataForm.values.password2, 
          }
          this.personalDataForm.reset({
            oldPassword: '',
            password1: '',
            password2: '',
          })
          await this.personalData.changePassword(passwordChanger);
        }
        await this.personalData.fetch({orgId: this.orgId});
        this.resetForms();
        confirmationDialog.confirm(translate("personalDataSaved", "Your data has been saved."), [{label: 'OK', value: true, className: 'button-ok'}]);
      } finally {
        await this.personalData.fetch({orgId: this.orgId});
        this.resetForms();
        this.flasher.setOther();
      }
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther();
    }
  }


  resetForms() {
    console.log(this.personalData)
    this.personalDataForm.reset({
      salutation: this.personalData.salutation,
      firstName: this.personalData.firstName,
      lastName: this.personalData.lastName,
      organization: this.personalData.organization,
      email: this.personalData.email,
      phone: this.personalData.phone,      
      mobilePhone:  this.personalData.mobilePhone,
      faxPhone:  this.personalData.faxPhone,
      timeZone:  this.personalData.timeZone,
      language:  this.personalData.language,      
    });
    this.personalAddressForms.forEach(o => {
      const address = this.personalData.addresses[o.refAddressTypeId] || {};
      o.reset({
        street: address.street,
        addition: address.addition,
        postalCode: address.postalCode,
        city: address.city,
        country: address.country,
      })
    });
  }

  async startOrUpdate({orgId}) {
    this.personalDataForm.readOnlyAll = false;
    this.personalDataForm.setPurpose(this.personalDataForm.PURPOSES.PROFILE_EDIT);
    this.orgId = orgId;
    this.personalDataForm.reset();
    this.personalAddressForms.forEach(o => o.reset());
    try {
      this.flasher.setOther('Loading.');
      await Promise.all([
        this.masterData.cFetch(),
        this.personalData.fetch({orgId}),
      ]);
      this.arGoHome = autorun(() => {
        if(!this.authentication.loggedIn) {
          this.navigation.goHome();
        }
      });
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther();
    }
    this.resetForms();
    let paf0 = this.personalAddressForms[0].values;
    let paf1 = this.personalAddressForms[1].values;
    runInAction(() => {
      this.usingPostAsBilling = true;
      for(let fld of 'street,addition,postalCode,city,country'.split(',')) {
        if(paf1[fld] && paf1[fld] !== paf0[fld]) {
          this.usingPostAsBilling = false;
          break;
        }
      }
    })

  }
  
  async stop() {
    this.arGoHome && this.arGoHome();
  }
}


// WEBPACK FOOTER //
// ./src/view/VUserProfile.js